import { useState } from 'react'
import { uniqueId } from 'lodash'

function useToast() {
	const [toastList, setToastList] = useState([])

	function addToastMessage(message, type) {
		if (!message) return

		const id = uniqueId();

		if (toastList.length > 2) {
			toastList.splice(0, 1)
		}

		if (typeof (message) === 'object' || message instanceof Error) {
			message = message?.message ?? message
		}

		if (typeof (message) === 'string') {
			setToastList([...toastList, { id, type, message }])
		}
	}

	return {
		toastList,
		setToastList,
		addToastMessage
	}
}

export default useToast
